import { FC, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Alert, Box, Typography } from "@mui/material";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import { formatItem } from "@framework/exchange";
import type { IAssetComponent } from "@framework/types";
import { FormGrid } from "@dzambalaorg/ui-kit";

import { sorter } from "../../../utils/sorter";
import { TokenInput } from "./token-input";

function splitLengthIntoTwosAndOne(len: number): number[] {
  if (len <= 0) return [];

  const result: number[] = [];

  const twosCount = Math.floor(len / 2);
  for (let i = 0; i < twosCount; i++) {
    result.push(2);
  }

  if (len % 2 === 1) {
    result.push(1);
  }

  return result;
}

export const TokenDepositInput: FC = () => {
  const form = useFormContext<any>();

  const { fields } = useFieldArray({ name: "deposit", control: form.control });
  const deposits = useWatch({ name: "deposit" });
  const assets: IAssetComponent[] = fields.map(
    (field, index) =>
      ({
        ...field,
        ...deposits[index],
      }) as IAssetComponent,
  );

  const sortedAssets = assets.sort(sorter("templateId"));

  return (
    <FormGrid columns={[1, 1]}>
      <Alert severity="info">
        <FormattedMessage id="alert.deposit" />
      </Alert>
      <FormGrid columns={splitLengthIntoTwosAndOne(sortedAssets.length)}>
        {sortedAssets.map((asset, index) => (
          <Fragment key={asset.id}>
            <TokenInput
              key={asset.id}
              prefix={`tokens[${index}]`}
              index={index}
              data={{
                contractIds: [asset.contractId],
                templateIds: asset.templateId ? [asset.templateId] : [],
              }}
              tokenType={asset.tokenType}
              readOnly={!!asset.templateId}
            />
            <Box mt={1} sx={{ textAlign: "left" }}>
              <Typography>{formatItem({ id: index, components: [asset] })}</Typography>
            </Box>
          </Fragment>
        ))}
      </FormGrid>
    </FormGrid>
  );
};
